import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader, StatusBadge, fmtDate } from "@/components/shared";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Check, X, CalendarDays } from "lucide-react";
import { toast } from "sonner";

export default function Attendance() {
  const [classes, setClasses] = useState([]);

  const load = async () => { const r = await api.get("/classes"); setClasses(r.data); };
  useEffect(() => { load(); }, []);

  const mark = async (classId, dogId, status) => {
    await api.post(`/classes/${classId}/attendance`, { dog_id: dogId, attendance_status: status, notes: "" });
    toast.success(`Marked ${status}`);
    await load();
  };

  return (
    <div>
      <PageHeader title="Attendance" subtitle="Mark attendance for dogs in your classes." />
      <div className="space-y-5">
        {classes.map((c) => (
          <Card key={c.id} className="border-border" data-testid="attendance-class">
            <CardHeader>
              <CardTitle className="font-heading text-lg flex items-center justify-between">
                <span>{c.name}</span>
                <StatusBadge value={c.status} />
              </CardTitle>
              <div className="text-sm text-muted-foreground flex items-center gap-1.5"><CalendarDays size={14} /> {fmtDate(c.date)} · {c.time} · {c.location_name}</div>
            </CardHeader>
            <CardContent className="space-y-2">
              {c.enrollments?.length ? c.enrollments.map((e) => (
                <div key={e.id} className="flex items-center justify-between p-3 rounded-lg border border-border/60" data-testid="attendance-row">
                  <span className="text-sm font-medium">{e.dog_name}</span>
                  <div className="flex items-center gap-2">
                    <StatusBadge value={e.attendance_status} />
                    <Button variant="outline" size="icon" className="h-7 w-7" onClick={() => mark(c.id, e.dog_id, "present")} data-testid="att-present"><Check size={14} className="text-green-600" /></Button>
                    <Button variant="outline" size="icon" className="h-7 w-7" onClick={() => mark(c.id, e.dog_id, "absent")} data-testid="att-absent"><X size={14} className="text-destructive" /></Button>
                  </div>
                </div>
              )) : <p className="text-sm text-muted-foreground">No dogs enrolled.</p>}
            </CardContent>
          </Card>
        ))}
        {classes.length === 0 && <p className="text-muted-foreground text-center py-12">No classes assigned to you.</p>}
      </div>
    </div>
  );
}
